import { InputFilterType } from '@share/common-types';
import { Tooltip } from 'antd';

export const MyPaymentListColumnMenu: any[] = [
  {
    description: 'ID',
    key: 'id',
    width: 80,
    order: 0, 
    display: true,
    type: InputFilterType.IntegerNumber,
  },
  {
    description: 'Account Name',
    key: 'accountName',
    width: 135,
    display: true,
    order: 1,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
  {
    description: 'Account Type',
    key: 'accountType',
    width: 135,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: true,
  },
  {
    description: 'Bank Name',
    key: 'bankName',
    width: 150,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: true,
  },
  {
    description: 'Last 4 Digits',
    key: 'lastFourDigits',
    width: 125,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: true,
  },
  {
    description: 'Status',
    key: 'status',
    width: 97,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: true,
    component: (paid: string) => {
      return (
        <div>
          <span
            className={`commonBadge ${
              paid === 'pending'
                ? 'commonBadge-warning'
                : paid === 'partial'
                ? 'commonBadge-danger'
                : 'commonBadge-success'
            }`}
          >
            {paid}
          </span>
        </div>
      );
    },
  },
  {
    description: 'Amount',
    key: 'amount',
    width: 130,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: true,
    component: (amount: string) => {
      return (
        <>
          <div className="d-flex align-items-center">
            <span className="paymentTotalValue">$ {amount} </span>
          </div>
        </>
      );
    },
  },
  {
    description: 'Paid Date',
    key: 'createdAt',
    width: 115,
    incomingDateFormat: 'MM/DD/YYYY',
    display: true,
    order: 4,
    type: InputFilterType.Date,
    displayConditions: true,
  },
];
